import Cookies from 'js-cookie';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';

/**
 * Fetches a CSV export from a backend endpoint (with the given query params)
 * and triggers a browser download. Uses the same auth cookie as apiRequest,
 * but bypasses its JSON-only response parsing since exports return a raw
 * text/csv body.
 */
export async function downloadCsvExport(
    endpoint: string,
    params: Record<string, string | number | null | undefined> = {}
): Promise<void> {
    const token = Cookies.get('crm_auth_token');

    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
            query.set(key, String(value));
        }
    });
    const queryString = query.toString();
    const cleanEndpoint = endpoint.replace(/^\/api/, '');
    const url = `${API_BASE_URL}${cleanEndpoint}${queryString ? `?${queryString}` : ''}`;

    const response = await fetch(url, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        credentials: 'include',
    });

    if (!response.ok) {
        throw new Error(`Export failed with status ${response.status}`);
    }

    const blob = await response.blob();
    const disposition = response.headers.get('Content-Disposition') || '';
    const filenameMatch = disposition.match(/filename="?([^"]+)"?/);
    const filename = filenameMatch?.[1] || 'export.csv';

    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
}
